// import { showlog } from "@liparistudios/js-utils";
import {showlog} from "../utils/dev-utils";

export const httpTimer = {
	start: (seconds?: number) => {
		let time = (seconds || 25) * 1000;
		return (
			new Promise((success, fail) => {
				setTimeout(() => fail("HTTP CALL WAITING TIME EXPIRED"), time);
			})
		)
	}
}
export const httpMethod = {
	GET: 'GET',
	POST: 'POST',
	PUT: 'PUT',
	DELETE: 'DELETE',
};

export const httpCall = (
	type: string,
	endpoint: string,
	body?: any,
	headersMap?: object | undefined
) => {


	showlog('controllo http request header', headersMap);

	let headers = {};
	let processedBody = body;
	if (type !== httpMethod.GET) {
		if (!!headersMap) {

			// @ts-ignore
			if (!!headersMap['Content-Type']) {
				// @ts-ignore
				if (headersMap['Content-Type'].indexOf('form') !== -1) {
					// processedBody = String(body);
					try {
						processedBody = [...body.entries()].map(e => encodeURIComponent(e[0]) + "=" + encodeURIComponent(e[1]));
					}
					catch (e) {
						processedBody = body;
					}

				}
				else {
					// niente
					processedBody = JSON.stringify(body);
				}
			}
			else {
				// niente
			}

		}
		else {
			if (typeof body === 'string') {
				// niente
				processedBody = body;  // gia avveniva
			}
			else {
				processedBody = JSON.stringify(body);
				headers['Content-Type'] = 'application/json';
			}
		}
	}
	else {
		processedBody = null;
	}


	let requestOptions: { method: string; headers: object; redirect: string; body: string | undefined | null } = {
		method: type,
		headers: Object.assign({ /*'Content-Type': 'application/json'*/ }, (!!headersMap ? { ...headersMap } : {}), headers),
		redirect: 'follow',
		body: processedBody
		// credentials: "include"
	};


	// correzione
	// endpoint = endpoint.split('//').join('/');

	let cUrl: string = `curl${(requestOptions.method === httpMethod.GET) ? "" : (" -X " + requestOptions.method)} `;
	cUrl += `${endpoint} `;
	// headers
	cUrl +=
		Object.keys(requestOptions.headers)
			// @ts-ignore
			.map((header: string) => `-H '${header}':'${requestOptions.headers[header]}'`)
			.join(" ")
		;
	// body
	if (!!processedBody) {
		cUrl += ` -d '${processedBody}'`
	}
	console.log("%c" + cUrl, "color:#ff0;");
	let startTime = (new Date()).getTime();


	showlog('request');
	showlog( requestOptions.headers );

	return Promise.race([
		httpTimer.start(40),
		// @ts-ignore
		fetch(endpoint, requestOptions)
			.then(result => {
				if (result.status !== 200) {
					throw result;
				}
				if (!!result && !!result.headers) {
					if (result.headers.get('Content-Type')?.indexOf('json') !== -1) {
						return result.json();
					}
					if (result.headers.get('Content-Type')?.indexOf('plain') !== -1) {
						return result.text();
					}
					if (result.headers.get('Content-Type')?.indexOf('text') !== -1) {
						return result.text();
					}
					if (
						result.headers.get('Content-Type')?.indexOf('octet-stream') !== -1
					) {
						return result.blob();
					}
				}
				return result;
			})

			.then(result => {
				// if( result.headers.get("Content-Type").indexOf("json") !== -1 ) return result.data;
				console.log(`%cRESPONSE [${((new Date()).getTime()) - startTime}ms]`, "color:#ff0;");
				console.log(result);
				return result;
			})

			.catch(error => {
				return Promise.reject(error);
			}),
	]);
};
